import { FilterInfoSticky } from "@faire/deprecated-retailer-visitor-shared/components/Filters/FilterInfoSticky";
import { FilterName } from "@faire/deprecated-retailer-visitor-shared/components/Filters/FilterName";
import { useFilterStore } from "@faire/deprecated-retailer-visitor-shared/components/Filters/useFilterStore";
import { NoResultsContainer } from "@faire/deprecated-retailer-visitor-shared/components/NoResults/index";
import { useCategoryPageScroll } from "@faire/deprecated-retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/CategoryPageShareables/hooks/useCategoryPageScroll";
import { LoggedOutCategoryPageHelmet } from "@faire/deprecated-retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedOutCategoryPage/__internal__/components/LoggedOutCategoryPageAboveFold/LoggedOutCategoryPageHelmet";
import { LoggedOutCategoryPageFilterSidebar } from "@faire/deprecated-retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedOutCategoryPage/__internal__/components/LoggedOutCategoryPageFilterAndResults/LoggedOutCategoryPageFilterSidebar";
import { LoggedOutCategoryPageProductList } from "@faire/deprecated-retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedOutCategoryPage/__internal__/components/LoggedOutCategoryPageFilterAndResults/LoggedOutCategoryPageProductList";
import { LoggedOutCategoryPageLayoutElements } from "@faire/deprecated-retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedOutCategoryPage/__internal__/components/LoggedOutCategoryPageLayoutElements/LoggedOutCategoryPageLayoutElements";
import { useLoggedOutCategoryPageLayoutElementsIsLoading } from "@faire/deprecated-retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedOutCategoryPage/__internal__/DataFetching/useLoggedOutCategoryPageLayoutElementsIsLoading";
import { useLoggedOutCategoryPageisLoadedAndHasNoResults } from "@faire/deprecated-retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedOutCategoryPage/__internal__/hooks/useLoggedOutCategoryPageisLoadedAndHasNoResults";
import { LoggedOutCategoryPageWrapper } from "@faire/deprecated-retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedOutCategoryPage/__internal__/styles/LoggedOutCategoryPageStyles";
import { LoggedOutCategoryPageHeroBannerSkeleton } from "@faire/deprecated-retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/CategoryPageLoadingSkeleton/LoggedOutCategoryPageLoadingSkeleton";
import { ILayoutElement } from "@faire/web-api--source/indigofair/data/ILayoutElement";
import { Column, Row } from "@faire/web/slate/Layout";
import { getSpacing } from "@faire/web/slate/spacing";
import React from "react";
import styled from "styled-components";

export const LoggedOutCategoryPageAboveFold: React.FC<{
  categoryPageLoadTimingRef?: React.Ref<HTMLDivElement>;
}> = ({ categoryPageLoadTimingRef }) => {
  const isLoadedAndHasNoResults =
    useLoggedOutCategoryPageisLoadedAndHasNoResults();

  const { scrollRef } = useCategoryPageScroll();

  const {
    clearAllFilters,
    data: { activeFilterCount },
  } = useFilterStore(["activeFilterCount"]);
  const isLayoutElementsLoading =
    useLoggedOutCategoryPageLayoutElementsIsLoading();

  return (
    <>
      <LoggedOutCategoryPageHelmet />

      {/* hero banner on C1 */}
      {isLayoutElementsLoading ? (
        <LoggedOutCategoryPageHeroBannerSkeleton />
      ) : (
        <LoggedOutCategoryPageLayoutElements
          placement={ILayoutElement.Placement.ABOVE_TITLE}
        />
      )}

      <LoggedOutCategoryPageWrapper>
        <LoggedOutCategoryPageLayoutElements
          placement={ILayoutElement.Placement.BELOW_BREADCRUMB}
        />
        <Row>
          <StyleLoggedOutCategoryPageFilterSidebar />
          <Column style={{ width: "100%" }}>
            <div ref={scrollRef} />
            {isLoadedAndHasNoResults ? (
              <NoResultsContainer
                showProductFirstResults
                hasFiltersApplied={activeFilterCount > 0}
                onClearFilters={clearAllFilters}
                divRef={categoryPageLoadTimingRef}
              />
            ) : (
              <>
                <FilterInfoSticky
                  name={FilterName.LOGGED_OUT_CATEGORY}
                  shouldNotShowFilterCollapsePillOnTabletAndBelow
                />
                <div
                  ref={categoryPageLoadTimingRef}
                  style={{ paddingTop: getSpacing("1x") }}
                >
                  <LoggedOutCategoryPageProductList />
                </div>
              </>
            )}
          </Column>
        </Row>
      </LoggedOutCategoryPageWrapper>
    </>
  );
};

const StyleLoggedOutCategoryPageFilterSidebar = styled(
  LoggedOutCategoryPageFilterSidebar
)`
  padding-top: ${getSpacing("2x")};
`;
